import { createContext, useContext, useState, useEffect, useCallback } from 'react';
import { useAuth } from './AuthContext';

const CompanyContext = createContext(null);

export function CompanyProvider({ children }) {
  const { apiCall, user } = useAuth();
  const [companies, setCompanies] = useState([]);
  const [selectedCompanyId, setSelectedCompanyId] = useState('');
  const [loading, setLoading] = useState(true);

  const fetchCompanies = useCallback(async () => {
    try {
      const res = await apiCall('get', '/companies');
      setCompanies(res.data.companies || []);
    } catch {
      setCompanies([]);
    } finally {
      setLoading(false);
    }
  }, [apiCall]);

  useEffect(() => {
    if (user) {
      fetchCompanies();
    }
  }, [user, fetchCompanies]);

  // Auto-migrate legacy company data on first load
  useEffect(() => {
    if (!loading && user && companies.length === 0 && user.company_name) {
      apiCall('post', '/companies/migrate').then(() => fetchCompanies()).catch(() => {});
    }
  }, [loading, user, companies.length, apiCall, fetchCompanies]);

  const selectedCompany = companies.find(c => c.id === selectedCompanyId) || null;

  return (
    <CompanyContext.Provider value={{
      companies,
      selectedCompanyId,
      setSelectedCompanyId,
      selectedCompany,
      fetchCompanies,
      loading,
    }}>
      {children}
    </CompanyContext.Provider>
  );
}

export function useCompany() {
  const ctx = useContext(CompanyContext);
  if (!ctx) throw new Error('useCompany must be inside CompanyProvider');
  return ctx;
}
